import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';
import {RouteConfig} from 'vue-router';

export default [
  {
    // Investment Models - Sections - Element
    path: '/advisor/investment-models/:sectionId(portfolios|glidepath|sleeves)?',
    name: 'InvestmentModelsByElement',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: (): any => import('@advisor/components/investmentmodels/InvestmentModels.vue'),
    meta: {
      breadCrumbs: {
        to: '/advisor/investment-models',
        text: '',
        title: 'Investment Models',
        componentId: COMPONENT_ID.INVMODEL,
      },
      platformArea: PLATFORM_AREA.INVMODEL,
      visibilityComponentId: COMPONENT_ID.INVMODEL,
      riaComponent: RIA_COMPONENT.INVESTMENT_MODELS,
    },
    props: true,
  },
  {
    // Investment Models - Sections - Element
    path: '/advisor/investment-models/portfolios/:elementId?',
    name: 'ModelPortfolioDetails',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: (): any => import('@advisor/components/investmentmodels/ModelPortfolio/ModelDetails.vue'),
    meta: {
      breadCrumbs: {
        to: '/advisor/investment-models',
        text: '',
        title: 'Investment Models',
        componentId: COMPONENT_ID.INVMODEL,
      },
      platformArea: PLATFORM_AREA.INVMODEL,
      visibilityComponentId: COMPONENT_ID.INVMODEL,
      riaComponent: RIA_COMPONENT.INVESTMENT_MODELS,
    },
    props: true,
  },

  {
    // Investment Models - Sections - Element
    path: '/advisor/investment-models/glidepath/:elementId?',
    name: 'GlidepathDetails',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: (): any => import('@advisor/components/investmentmodels/GlidePathFramework/FrameworkDetails.vue'),
    meta: {
      breadCrumbs: {
        to: '/advisor/investment-models',
        text: '',
        title: 'Investment Models',
        componentId: COMPONENT_ID.INVMODEL,
      },
      platformArea: PLATFORM_AREA.INVMODEL,
      visibilityComponentId: COMPONENT_ID.INVMODEL,
      riaComponent: RIA_COMPONENT.INVESTMENT_MODELS,
    },
    props: true,
  },

  {
    // Investment Models - Sections - Element
    path: '/advisor/investment-models/sleeves/:elementId?',
    name: 'SleeveDetails',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: (): any => import('@advisor/components/investmentmodels/Sleeves/SleeveDetails.vue'),
    meta: {
      breadCrumbs: {
        to: '/advisor/investment-models',
        text: '',
        title: 'Investment Models',
        componentId: COMPONENT_ID.INVMODEL,
      },
      platformArea: PLATFORM_AREA.INVMODEL,
      visibilityComponentId: COMPONENT_ID.INVMODEL,
      riaComponent: RIA_COMPONENT.INVESTMENT_MODELS,
    },
    props: true,
  },
] as RouteConfig[];
